import type { MachineSetupRepository } from '../data/machine-setup-repository';
import type { DeviceSuggestion } from '../types/machine-setup-types';

export class GetDevicesForActorUseCase {
  constructor(private readonly repository: MachineSetupRepository) {}

  async execute(actorId: number): Promise<DeviceSuggestion[]> {
    return this.repository.getDevicesForActor(actorId);
  }
}
